const machineTransport = [
  {
    model: "A Machine transporter",
    maximum_authorized_mass: "2700 KG",
    axles: "2 X AS 1350 KG",
    cargo_dimensions: "300 X 150 X 34 CM",
    total_length: "",
    own_mass: "",
    loading_capacity: "2090 KG",
    price: 3750,
    img: "images/aruszallitok/1.jpg",
    imgAlt: "",
  },
  {
    model: "B Machine transporter",
    maximum_authorized_mass: "3000 KG",
    axles: "2 X AS 1500 KG",
    cargo_dimensions: "300 X 150 X 34 CM",
    total_length: "",
    own_mass: "",
    loading_capacity: "2350 KG",
    price: 3950,
    img: "images/aruszallitok/2.jpg",
    imgAlt: "",
  },
  {
    model: "C Machine transporter",
    maximum_authorized_mass: "3500 KG",
    axles: "2 X AS 1800 KG",
    cargo_dimensions: "300 X 150 X 34 CM",
    total_length: "",
    own_mass: "",
    loading_capacity: "2830 KG",
    price: 4150,
    img: "images/aruszallitok/3.jpg",
    imgAlt: "",
  },
  {
    model: "D Machine transporter",
    maximum_authorized_mass: "2700 KG",
    axles: "2 X AS 1350 KG",
    cargo_dimensions: "400 X 150 X 34 CM",
    total_length: "",
    own_mass: "",
    loading_capacity: "2000 KG",
    price: 4250,
    img: "images/aruszallitok/4.jpg",
    imgAlt: "",
  },
  {
    model: "E Machine transporter",
    maximum_authorized_mass: "3000 KG",
    axles: "2 X AS 1500 KG",
    cargo_dimensions: "400 X 150 X 34 CM",
    total_length: "",
    own_mass: "",
    loading_capacity: "2260 KG",
    price: 4450,
    img: "images/aruszallitok/5.jpg",
    imgAlt: "",
  },
  {
    model: "F Machine transporter",
    maximum_authorized_mass: "3500 KG",
    axles: "2 X AS 1800 KG",
    cargo_dimensions: "400 X 150 X 34 CM",
    total_length: "",
    own_mass: "",
    loading_capacity: "2730 KG",
    price: 4550,
    img: "images/aruszallitok/5.jpg",
    imgAlt: "",
  },
  {
    model: "G Machine transporter",
    maximum_authorized_mass: "3500 KG",
    axles: "3 X AS 1350 KG",
    cargo_dimensions: "400 X 150 X 34 CM",
    total_length: "",
    own_mass: "",
    loading_capacity: "2700 KG",
    price: 4700,
    img: "images/aruszallitok/4.jpg",
    imgAlt: "",
  },
  {
    model: "H Machine transporter",
    maximum_authorized_mass: "3500 KG",
    axles: "3 X AS 1500 KG",
    cargo_dimensions: "400 X 150 X 34 CM",
    total_length: "",
    own_mass: "",
    loading_capacity: "2650 KG",
    price: 4900,
    img: "images/aruszallitok/4.jpg",
    imgAlt: "",
  },
  {
    model: "I Machine transporter",
    maximum_authorized_mass: "3500 KG",
    axles: "3 X AS 1800 KG",
    cargo_dimensions: "400 X 150 X 34 CM",
    total_length: "",
    own_mass: "",
    loading_capacity: "2620 KG",
    price: 5200,
    img: "images/aruszallitok/7.jpg",
    imgAlt: "",
  },
  {
    model: "J Machine transporter",
    maximum_authorized_mass: "2700 KG",
    axles: "2 X AS 1350 KG",
    cargo_dimensions: "400 X 180 X 34 CM",
    total_length: "",
    own_mass: "",
    loading_capacity: "1940 KG",
    price: 4350,
    img: "images/aruszallitok/7.jpg",
    imgAlt: "",
  },
  {
    model: "K Machine transporter",
    maximum_authorized_mass: "3000 KG",
    axles: "2 X AS 1500 KG",
    cargo_dimensions: "400 X 180 X 34 CM",
    total_length: "",
    own_mass: "",
    loading_capacity: "2190 KG",
    price: 4550,
    img: "images/aruszallitok/7.jpg",
    imgAlt: "",
  },
  {
    model: "L Machine transporter",
    maximum_authorized_mass: "3500 KG",
    axles: "2 X AS 1800 KG",
    cargo_dimensions: "400 X 180 X 34 CM",
    total_length: "",
    own_mass: "",
    loading_capacity: "2670 KG",
    price: 4650,
    img: "images/aruszallitok/7.jpg",
    imgAlt: "",
  },
  {
    model: "M Machine transporter",
    maximum_authorized_mass: "3500 KG",
    axles: "3 X AS 1350 KG",
    cargo_dimensions: "400 X 180 X 34 CM",
    total_length: "",
    own_mass: "",
    loading_capacity: "2660 KG",
    price: 4800,
    img: "images/aruszallitok/7.jpg",
    imgAlt: "",
  },
  {
    model: "N Machine transporter",
    maximum_authorized_mass: "3500 KG",
    axles: "3 X AS 1500 KG",
    cargo_dimensions: "400 X 180 X 34 CM",
    total_length: "",
    own_mass: "",
    loading_capacity: "2600 KG",
    price: 4950,
    img: "images/aruszallitok/7.jpg",
    imgAlt: "",
  },
  {
    model: "O Machine transporter",
    maximum_authorized_mass: "3500 KG",
    axles: "3 X AS 1800 KG",
    cargo_dimensions: "400 X 180 X 34 CM",
    total_length: "",
    own_mass: "",
    loading_capacity: "2570 KG",
    price: 5300,
    img: "images/aruszallitok/7.jpg",
    imgAlt: "",
  },
  {
    model: "P Machine transporter",
    maximum_authorized_mass: "2700 KG",
    axles: "2 X AS 1350 KG",
    cargo_dimensions: "480 X 180 X 34 CM",
    total_length: "",
    own_mass: "",
    loading_capacity: "1910 KG",
    price: 4850,
    img: "images/aruszallitok/7.jpg",
    imgAlt: "",
  },
  {
    model: "Q Machine transporter",
    maximum_authorized_mass: "3000 KG",
    axles: "2 X AS 1500 KG",
    cargo_dimensions: "480 X 180 X 34 CM",
    total_length: "",
    own_mass: "",
    loading_capacity: "2160 KG",
    price: 5050,
    img: "images/aruszallitok/7.jpg",
    imgAlt: "",
  },
  {
    model: "R Machine transporter",
    maximum_authorized_mass: "3500 KG",
    axles: "2 X AS 1800 KG",
    cargo_dimensions: "480 X 180 X 34 CM",
    total_length: "",
    own_mass: "",
    loading_capacity: "2640 KG",
    price: 5150,
    img: "images/aruszallitok/7.jpg",
    imgAlt: "",
  },
  {
    model: "S Machine transporter",
    maximum_authorized_mass: "3500 KG",
    axles: "3 X AS 1350 KG",
    cargo_dimensions: "480 X 180 X 34 CM",
    total_length: "",
    own_mass: "",
    loading_capacity: "2630 KG",
    price: 5300,
    img: "images/aruszallitok/7.jpg",
    imgAlt: "",
  },
  {
    model: "T Machine transporter",
    maximum_authorized_mass: "3500 KG",
    axles: "3 X AS 1500 KG",
    cargo_dimensions: "480 X 180 X 34 CM",
    total_length: "",
    own_mass: "",
    loading_capacity: "2570 KG",
    price: 5450,
    img: "images/aruszallitok/7.jpg",
    imgAlt: "",
  },
  {
    model: "U Machine transporter",
    maximum_authorized_mass: "3500 KG",
    axles: "3 X AS 1800 KG",
    cargo_dimensions: "480 X 180 X 34 CM",
    total_length: "",
    own_mass: "",
    loading_capacity: "2540 KG",
    price: 5800,
    img: "images/aruszallitok/7.jpg",
    imgAlt: "",
  },
];

export default machineTransport;
